<rt-dialog-header
  [heading]="'app.visibility.visible_to_selected' | translate"
  [subheading]="'app.visibility.selected_team_members' | translate"
/>

<rt-dialog-body layout-vertical>
  <rt-box variant="vertical background no-padding">
    <div class="search">
      <rt-form-field padding-medium padding-bottom-small-xx>
        <rt-input
          [placeholder]="
            (selectedTab === Tab.TeamMembers
              ? 'app.common.placeholders.search.team_members.other'
              : 'app.common.placeholders.search.roles.other'
            ) | translate
          "
          [autoFocus]="true"
          [formControl]="searchControl"
          [value]="searchQuery"
          (valueChange)="onSearchQueryChange($event)"
          variant="rounded"
        >
          <rt-icon prefix name="search" />
          @if (isSearching()) {
            <rt-icon-button
              suffix
              (click)="cancelSearch()"
              variant="plain"
              shape="square"
              iconName="close"
              size="small"
            />
          }
        </rt-input>
      </rt-form-field>

      <div layout-horizontal layout-align-items-center>
        <rt-tabs [hasBottomSeparator]="false" margin-left>
          <rt-tab
            (click)="selectTab(Tab.TeamMembers)"
            [class.current]="selectedTab === Tab.TeamMembers"
          >
            {{ 'app.visibility.team_members' | translate }}
          </rt-tab>
          <rt-tab
            (click)="selectTab(Tab.HiringRoles)"
            [class.current]="selectedTab === Tab.HiringRoles"
          >
            {{ 'app.visibility.hiring_roles' | translate }}
          </rt-tab>
        </rt-tabs>

        <rt-group class="select-options" margin-left-auto margin-right-medium>
          <rt-button variant="plain" (click)="selectAll()">
            {{ 'app.common.all' | translate }}
          </rt-button>
          <rt-button variant="plain" (click)="selectNone()">
            {{ 'app.common.none' | translate }}
          </rt-button>
        </rt-group>
      </div>
    </div>

    <rt-divider variant="line" />

    @if (selectedTab === Tab.TeamMembers) {
      <div
        class="results"
        infiniteScroll
        [infiniteScrollDistance]="9"
        [infiniteScrollThrottle]="0"
        [scrollWindow]="false"
        (scrolled)="onScroll()"
      >
        <ng-container
          [ngTemplateOutlet]="adminList"
          [ngTemplateOutletContext]="{ $implicit: false }"
        />
        @if (groupUsersByAccess && !!visibleDisallowedUsers?.length) {
          <div class="header" padding-lr padding-tb-small>
            <rt-heading variant="subheading">
              {{ 'app.candidate.admin_select.no_access.header' | translate | uppercase }}
            </rt-heading>
          </div>
          <ng-container
            [ngTemplateOutlet]="adminList"
            [ngTemplateOutletContext]="{ $implicit: true }"
          />
        }
        <ng-template #adminList let-isDisallowedList>
          @for (
            admin of isDisallowedList ? visibleDisallowedUsers : visibleAdmins;
            track trackById($index, admin);
            let isLast = $last
          ) {
            <rt-visibility-admin-item
              [admin]="admin"
              [kind]="isDisallowedList ? 'no-access' : 'admin'"
              [currentAdmin]="currentAdmin"
              [hasDivider]="groupUsersByAccess ? (isDisallowedList ? !isLast : true) : !isLast"
              [form]="isDisallowedList ? null : controlForAdmin(admin)"
              [roleAssignmentsGroup]="roleAssignmentsGroup.value"
              [checked]="isDisallowedList ? false : assignmentsGroup.controls[admin.id]?.value"
              [rtTooltipMaxWidth]="260"
              [rtTooltip]="disabledUserCopy | translate"
              [rtTooltipEnabled]="isDisallowedList"
              [groupUsersByAccess]="groupUsersByAccess"
              rtTooltipPosition="left"
              (click)="$event.stopImmediatePropagation()"
              (toggleAssignment)="!isDisallowedList && toggleAssignment(admin)"
              (checkboxClick)="!isDisallowedList && detectChanges()"
            />
          }
        </ng-template>
      </div>
    }

    @if (selectedTab === Tab.HiringRoles) {
      <div
        class="results"
        infiniteScroll
        [infiniteScrollDistance]="9"
        [infiniteScrollThrottle]="0"
        [scrollWindow]="false"
        (scrolled)="onScroll()"
      >
        @for (
          roleWithAdmins of visibleRolesWithAdmins;
          track trackById($index, roleWithAdmins);
          let isLast = $last
        ) {
          <rt-visibility-admin-item
            [roleWithAdmins]="roleWithAdmins"
            [kind]="'role'"
            [form]="controlForRole(roleWithAdmins)"
            [checked]="roleAssignmentsGroup.controls[roleWithAdmins.id].value"
            [hasDivider]="!isLast"
            [currentAdmin]="currentAdmin"
            (toggleAssignment)="toggleRoleAssignment(roleWithAdmins)"
            (checkboxClick)="detectChanges()"
          />
        }
      </div>
    }

    @if (
      (!visibleAdmins.length &&
        !visibleDisallowedUsers?.length &&
        selectedTab === Tab.TeamMembers) ||
      (!rolesWithAdmins.length && selectedTab === Tab.HiringRoles)
    ) {
      <rt-empty-state
        [icon]="'search'"
        [title]="'app.common.no_results_found' | translate"
        variant="small"
        margin-medium
      >
        <rt-button (click)="cancelSearch()" variant="tertiary">
          {{ 'app.assignments.editor.clear_search' | translate }}
        </rt-button>
      </rt-empty-state>
    }
  </rt-box>
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button (click)="onCancelClick()" variant="plain">
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button (click)="onSaveClick()" variant="primary">
    {{ 'app.common.save' | translate }}
  </rt-button>
</rt-dialog-footer>
